import { cn } from 'src/utils'

// Small pill button for the due-date presets and reminder quick options.
// `active` highlights the selected preset; `muted` styles the Clear action;
// `disabled` greys out options that would resolve to an invalid time (e.g. a
// reminder in the past).
const QuickPill = ({
  active = false,
  muted = false,
  disabled = false,
  onClick,
  children,
}) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className={cn(
      'whitespace-nowrap rounded-md border px-2 py-0.5 text-xs transition-colors',
      disabled
        ? 'cursor-not-allowed border-doubleNickel-gray-100 text-doubleNickel-gray-300'
        : active
        ? 'border-doubleNickel-brand-200 bg-doubleNickel-brand-25 text-doubleNickel-brand-600'
        : muted
        ? 'border-doubleNickel-gray-200 text-doubleNickel-gray-400 hover:bg-doubleNickel-gray-50'
        : 'border-doubleNickel-gray-200 text-doubleNickel-gray-600 hover:bg-doubleNickel-gray-50'
    )}
  >
    {children}
  </button>
)

export default QuickPill
